'use client';

import type { FormInputProps, FormType } from '../../types/types';

import { FormField } from '../FormField/FormField';
import { PasswordInput } from '../../../components/ui';
import { useFormContext } from 'react-hook-form';

export const FormPasswordInput = <T extends FormType>({
	name,
	label,
	helperText,
	optionalText,
	isRequired,
	_formField,
	...rest
}: FormInputProps<T>) => {
	const { register, formState } = useFormContext();

	return (
		<FormField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={isRequired}
			{..._formField}
		>
			<PasswordInput disabled={formState.isSubmitting} {...register(name)} {...rest} />
		</FormField>
	);
};